<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';

	import historicBuildingsImage from './images/historic-preservation-hub-001.jpg';
	import historicHouseImage from './images/historic-preservation-hub-002.jpg';
</script>

<Section backgroundColor={'white'}>
	<p>
		Historic preservation enriches our communities by preserving homes and
		buildings that tell stories about our past and guide us into the future. It
		pushes back against the cultural ethos of “new is better”; that anything old
		should be scrapped in the name of progress or better living. Home insulation
		tips and energy upgrades don't need to include destruction. That way of
		thinking has no endpoint and devours buildings, history, time, and energy.
	</p>
	<Image src={historicBuildingsImage} alt="historic buildings side by side" />
	<p>
		We come at historic preservation through windows. Their design and placement
		determines the balance and beauty of a home or building. But, the window
		replacement industry has many people mistakenly believing that to make their
		homes energy efficient they need to replace their windows and that <a
			href="https://www.youtube.com/watch?v=4oHwFOn9FBo&list=PLe64DtqOvhg50qFwIlSNfhkcItlOp4_1s"
			target="_blank"
			rel="noreferrer">restoring old windows</a
		> is more difficult than it is.
	</p>
	<p>
		Many of America's historic windows were made from trees 200-300 years old at
		the time they were logged. The wood is dense and rot resistant. You can't
		find it anymore. And a lot of the glass was handblown before modern,
		machine-made optically-perfect float glass became widely available.
	</p>
	<p>
		We're honored to work with historic preservation organizations all over the
		country and regularly host free Window Hero Webinars featuring window
		restoration experts and master craftsmen who teach people how to care for
		their old windows.
	</p>
	<Image
		src={historicHouseImage}
		alt="a pre-Revolutionary War Colonial house"
	/>
	<p>
		Our inserts have helped preserve some really cool spaces: an iconic Case
		Study home; a Frank Lloyd Wright house, a pre-Revolutionary War Colonial in
		New Hampshire; the Homewood Museum at Johns Hopkins and many more.
	</p>
	<p>
		We even preserved windows at Alcatraz, the former federal penitentiary and
		National Historic Landmark when the artist Ai WeiWei did a human rights
		installation there.
	</p>
</Section>

<GetAFreeEstimate />
<Awards />
<FeaturedArticles />
